import { HorizontalContainer } from '@american-autonomy/ag-ui';

import JohnDeereIcon from 'components/icons/JohnDeereIcon';
import CaptionText from 'components/text/CaptionText';

import useTranslation from './hooks/useTranslation';

import { JD_TAG_PREFIX, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SourceBadge: FunctionComponent<Props> = ({ className = '', name, testId = TEST_ID }) => {
    const { JOHN_DEERE } = useTranslation();

    const isJohnDeereSource = name.includes(JD_TAG_PREFIX);

    if (!isJohnDeereSource) {
        return null;
    }

    return (
        <HorizontalContainer className={`${className} ${styles.sourceBadge}`} testId={testId}>
            <JohnDeereIcon />

            <CaptionText text={JOHN_DEERE} />
        </HorizontalContainer>
    );
};

export default SourceBadge;
